/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Type Mst Service
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ItemTypeApi} from '../../api/master/item-type-mst.api';
import { switchMap, map } from 'rxjs/operators';
import { ItemTypeData,ItemType  } from '../../interface/master/item-type-mst';

@Injectable()
export class ItemTypeService extends ItemTypeData {

  constructor(private api: ItemTypeApi) {
    super();
  }


  list(url: string): Observable<ItemType[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<ItemType>{
      return this.api.getById(url);
  }

  create(url: string, data:ItemType): Observable<ItemType> {
    return this.api.add(url,data);
  }

  update(url: string, data:ItemType): Observable<ItemType> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
